import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonetadm.institutes.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kreonetadm-institutes-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonetadm.institutes.list/view.scss */
.container {
  height: max-content;
}

.table-responsive {
  margin: auto;
  padding: 1rem;
}

.btn-plus {
  width: 110px;
  height: 57px;
  border: none;
  border-radius: 10px;
  color: white;
  font: normal normal bold 18px/21px NanumSquareOTF;
  background-color: #5263FF;
}

.card-table .table {
  position: absolute;
}
.card-table .table th {
  font-size: 14px;
  background: #EFF4FE;
  padding: 8px 12px;
}
.card-table .table thead {
  position: sticky;
  top: 0;
}
.card-table .table tbody {
  background: #fff;
}
.card-table .table tbody tr {
  cursor: pointer;
}
.card-table .table tbody tr:hover {
  background: var(--wc-background);
}
.card-table .table tbody td {
  white-space: nowrap;
}
.card-table .table tbody .user-status-icon {
  display: inline-block;
  width: 20px;
  text-align: center;
  line-height: 1;
  padding: 4px 0;
  font-size: 12px;
  border-radius: 10px;
  background: var(--wc-blue);
  color: #fff;
}
.card-table .table tbody .btn i {
  width: 16px;
}

.table-card {
  width: 1592px;
  height: 844px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1019607843);
  border-radius: 20px;
}

.select-cate {
  width: 93px;
  height: 40px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 999px;
  border: none;
}

.workspace-list-item {
  max-width: 1592px;
  margin: auto;
}
.workspace-list-item .row {
  padding: 0.5rem;
}

.featured-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70px 50px;
  border-radius: 10px;
  margin-left: 5px;
}
@media (max-width: 768px) {
  .featured-image {
    height: 200px;
    margin: 0;
    margin-bottom: 32px;
  }
}

.row {
  padding: 1rem 2rem;
}
.row .form-select {
  border: 1px solid #929DAB;
  border-radius: 10px;
  width: 132px;
  height: 44px;
}

.search {
  background: white;
  width: 361px;
  height: 40px;
  border-radius: 999px;
}
.search i {
  width: 18px;
  height: 18px;
  color: white;
}
.search .form-control {
  border-radius: 999px;
  border: none;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  padding-left: 25px;
  z-index: 3;
  color: var(--unnamed-color-6d6d6d);
  text-align: left;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) var(--unnamed-font-size-18)/var(--unnamed-line-spacing-21) var(--unnamed-font-family-nanumsquareotf);
  box-shadow: none;
}
.search .btn-search {
  width: 48px;
  height: 40px;
  border: none;
  background: #5263FF 0% 0% no-repeat padding-box;
  border-radius: 0px 999px 999px 0px;
  z-index: 3;
}

.card {
  max-width: 1592px;
  margin: auto;
}

.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  max-width: 640px;
  background: #fff;
  border-left: 1px solid var(--wc-border);
}
.sidebar .card {
  border-radius: 0;
  border: none;
}
.sidebar .card > * {
  border-radius: 0;
}

.device-editor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.wiz-form {
  background-color: #fff;
  text-align: left;
}
.wiz-form .wiz-form-label {
  font-size: 0.875rem;
}
.wiz-form .form-control {
  padding: 0.5625rem 0;
  font-size: 0.875rem;
}`],
})
export class PortalKreonetadmInstitutesListComponent implements OnInit {
    public sidebar: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('admin', '/');
        await this.load();
    }
    public search_word = "";
    public listloaded: boolean = false;
    public list: any = [];
    public data: any = {};

    public search: any = {
        page: 1,
        text: ''
    };

    public pagenation: any = {
        end: -1,
        start: -1,
    };
    public async alert(message: string, status: any = "error") {
        return await this.service.alert.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: "확인",
            status: status
        });
    }


    private async searchWord() {
        if (this.search_word.length === 0) {
            await this.alert("검색어를 입력해주세요.");

        }
        this.pagenation.page = 1;
        await this.load();
    }


    public async load(page: number = 1) {
        this.listloaded = false;
        let { code, data } = await wiz.call("list", { page: page, text: this.search.text });
        if (code != 200) return;
        let { rows, lastpage } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.search.page = page;
        this.list = rows;
        console.log(this.list)
        this.pagenation.start = startpage;
        this.pagenation.end = lastpage;
        this.listloaded = true;
        await this.service.render();
    }

    public async pageMove(page: number) {
        await this.load(page);
    }

    public async sidebarClose() {
        this.sidebar = null;
        await this.service.render();
    }

    public async create() {
        this.data = {};
        this.sidebar = 'new';
        await this.service.render();
    }

    public async update() {
        let data = this.data;
        const { code } = await wiz.call("update", data);
        if (code == 200) {
            await this.alert("저장되었습니다", 'success');
            await this.sidebarClose();
            await this.load(this.search.page);
        } else {
            await this.alert("저장 중 오류가 발생했습니다.", 'error');
        }
        await this.service.render();
    }
}

export default PortalKreonetadmInstitutesListComponent;